




































































import Vue from "vue";
import Dropdown from "@/components/dropdown/DropDown.vue";

import EntitiesTransferInline from "@/components/transfer/EntitiesTransferInline.vue";
import { computed, ref, Ref } from "@vue/composition-api";
import { PopulationTypeHelper, POPULATION_TYPE } from "@/common/models";
import { IconAndTextItemType } from "@/components/dropdown/items.type";
import { AppAnalytics } from "@/analytics";
import { SharedState } from "@/common/state";
export default Vue.extend({
  components: {
    Dropdown,
    EntitiesTransferInline,
  },
  setup(_, { emit }) {
    const entitiesType = PopulationTypeHelper.displayList(
      [
        POPULATION_TYPE.EMPLOYEE,
        POPULATION_TYPE.ORGANIZATION,
        POPULATION_TYPE.CONTACT,
        POPULATION_TYPE.PRIVATE_EMAIL,
        POPULATION_TYPE.FOLDER,
        POPULATION_TYPE.FILE,
        POPULATION_TYPE.LABEL,
      ],
      true
    )
      .filter((p) => {
        if (
          SharedState.data_sources_contain_only_gmail.value &&
          p.id === POPULATION_TYPE.FOLDER
        ) {
          return false;
        }
        return true;
      })
      .map((item) => {
        return {
          ...item,
          name: item.name + "s",
          type: "iconAndText",
          checked: false,
          disable: item.id == POPULATION_TYPE.FILE,
        } as IconAndTextItemType;
      });

    const selectedType = ref(POPULATION_TYPE.EMPLOYEE);

    const selectedEntityType = ref([
      entitiesType.find((t) => t.id === POPULATION_TYPE.EMPLOYEE),
    ]);

    const onEntityTypeChanged = (items: IconAndTextItemType[]) => {
      if (selectedType.value !== (items[0].id as POPULATION_TYPE)) {
        summaryItem.value = null;
      }
      selectedType.value = items[0].id as POPULATION_TYPE;
      selectedEntityType.value = items;
      selectedItems.value = [];
      AppAnalytics.report({
        component: "Investigation",
        eventName: `Investigation_tier#1 entities dropdown_select ${PopulationTypeHelper.asString(
          items[0].id as POPULATION_TYPE
        )}`,
      });
    };

    const selectedItems = ref([]);

    const showResults = async () => {
      const selectedItem: any = selectedItems.value[0];
      if (selectedItem.short_name) {
        selectedItem.name = selectedItem.short_name;
      }
      emit("investigate", selectedItem);
      AppAnalytics.report({
        component: "Investigation",
        eventName: `Investigation_tier#1 show results button ${PopulationTypeHelper.asString(
          selectedType.value
        )}`,
      });
    };

    const disableShowResults = computed(() => selectedItems.value.length === 0);

    const summaryItem: Ref<{ id: string; type: POPULATION_TYPE } | null> = ref(
      null
    );
    const onItemChecked = async (
      items: Array<{ id: string; type: POPULATION_TYPE }>
    ) => {
      const [item] = items;
      summaryItem.value = item;
    };

    const onSearchFocus = () => {
      AppAnalytics.report({
        component: "Investigation",
        eventName: "user pressed the entities search box",
      });
    };

    return {
      showResults,
      disableShowResults,
      entitiesType,
      selectedEntityType,
      onEntityTypeChanged,
      selectedType,
      selectedItems,
      summaryItem,
      onItemChecked,
      onSearchFocus,
    };
  },
});
